import { FeConfigType } from "config/config";
import { PartitionByWidgetConfig } from "containers/Dashboard/types";
import { CustomObjectCanvasScreen } from "./CustomObjectCanvas";
import { ObjectTemplateCanvasScreen } from "./ObjectTemplateCanvas";
import styles from "./RelationGraphEmbed.module.scss";

export type RelationGraphMode = "object_template" | "custom_object";

export interface RelationGraphEmbedProps {
    mode: RelationGraphMode;
    /** Filter applied to object_template_list (or derived from location when set). */
    filter?: unknown;
    /** For custom_object mode: seed the graph from custom_object_list matching this filter. */
    customObjectFilter?: unknown;
    /** Latest N custom objects per distinct field (uses partition_by). */
    partitionBy?: PartitionByWidgetConfig;
    /** Max groups when using partitionBy. */
    groupLimit?: number;
    /** Default order when partitionBy.order is omitted. */
    order?: string;
    location?: FeConfigType;
    locationId?: string;
    className?: string;
}

/**
 * Filter-scoped, read-only relation graph for embedding in dashboards and other surfaces.
 */
export const RelationGraphEmbed = ({
    mode,
    filter,
    customObjectFilter,
    partitionBy,
    groupLimit,
    order,
    location,
    locationId,
    className,
}: RelationGraphEmbedProps) => (
    <div className={`${styles.relationGraphEmbed} ${className ?? ""}`}>
        <div className={styles.relationGraphEmbed__body}>
            {mode === "custom_object" ? (
                <CustomObjectCanvasScreen
                    embedMode
                    filter={filter}
                    customObjectFilter={customObjectFilter}
                    partitionBy={partitionBy}
                    customObjectGroupLimit={groupLimit}
                    customObjectOrder={order}
                    location={location}
                    locationId={locationId}
                />
            ) : (
                <ObjectTemplateCanvasScreen
                    embedMode
                    filter={filter}
                    location={location}
                    locationId={locationId}
                />
            )}
        </div>
    </div>
);

export const RelationGraphEmbedScreen = (props: RelationGraphEmbedProps) => (
    <RelationGraphEmbed {...props} />
);
